import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { UserService, CustomerType } from 'app/services/user.service';
import { IntegratorService } from 'app/services/integrator.service';

export interface Agency {
	name: string;
	id: number;
	adminEmails: string[];
}

@Component({
	selector: 'app-feature-available-agencies',
	templateUrl: './feature-available-agencies.component.html',
	styleUrls: ['./feature-available-agencies.component.css']
})
export class FeatureAvailableAgenciesComponent implements OnInit, OnChanges {

	selectedAgency: Agency;
	agencyList: Agency[] = [];
	@Input() selectedAgencyId: number;
	@Input() selectWidth: string;
	@Input() agencyType: CustomerType;
	@Output() changeAgency: EventEmitter<Agency> = new EventEmitter();

	public customerId: number;

	constructor(
		private integratorService: IntegratorService,
		private userService: UserService
	) { }

	onSelectAgency() {
		// this.userService.selectedCustomerId.next(this.selectedAgency.id);
		this.userService.selectedCustomer.next({
			id: this.selectedAgency.id,
			nameShort: this.selectedAgency.name,
			adminEmails: this.selectedAgency.adminEmails
		});
		this.changeAgency.emit(this.selectedAgency);
	}
	private selectAgencyFromCode() {
		console.log('SelectAgencyFromCode()');
		console.log('selectedAgencyId', this.selectedAgencyId, this.selectedAgency);
		if (this.selectedAgencyId) {
			this.selectedAgency = this.agencyList.find((a) => a.id === this.selectedAgencyId);
			const id = this.selectedAgency ? this.selectedAgency.id : null;
			if (this.userService.selectedCustomer.getValue() && this.userService.selectedCustomer.getValue().id !== id) {
				// this.userService.selectedCustomerId.next(id);
				this.userService.selectedCustomer.next({
					id: this.selectedAgency.id,
					nameShort: this.selectedAgency.name,
					adminEmails: this.selectedAgency.adminEmails
				});
			}
		}
	}
	async ngOnInit() {
		this.selectWidth = this.selectWidth || '400px';
		//
		this.customerId = this.userService.getUserInfo().customerId;
		
		switch (this.agencyType) {
			case 'integrator':
				if (!this.userService.clients) {
					await this.integratorService.getIntegratorClients();
				}
				this.agencyList = this.userService.clients.map((c) => {
					return {
						name: c.cusNameShort,
						id: c.cusId,
						adminEmails: c.adminEmails
					};
				});
				if (!this.selectedAgencyId && this.agencyList[0]) {
					this.selectedAgencyId = this.agencyList[0].id;
					this.selectAgencyFromCode();
				}
				break;
			default:
				let list = [{
					id: this.userService.customerInfo.id,
					name: this.userService.customerInfo.nameShort,
					adminEmails: this.userService.customerInfo.adminEmails
				}];
				// Agency list include current customer and its children
				// Only admin can see child agencies
				if (this.userService.getUserInfo().isAdmin) {
					list = this.userService.customerInfo.children.concat(list);
				}
				this.agencyList = list;

		}
		this.selectAgencyFromCode();
	}
	ngOnChanges(changes: SimpleChanges) {
		if (changes.selectedAgencyId && !changes.selectedAgencyId.firstChange) {
			this.selectAgencyFromCode();
		}
	}
}
